import { SET_GRID_VIEW, CLEAR_GRID_VIEW } from "../actions/type";

// Load initial state from localStorage
const loadGridView = () => {
  try {
    const savedGridView = localStorage.getItem("isSmallGrid");
    return savedGridView === "true";
  } catch (e) {
    return false;
  }
};

const INIT_STATE = {
  isSmallGrid: loadGridView()
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case SET_GRID_VIEW:
      // Persist to localStorage
      try {
        localStorage.setItem("isSmallGrid", String(payload));
      } catch (e) {
        console.error("Failed to save isSmallGrid to localStorage:", e);
      }
      return { ...state, isSmallGrid: payload };
    case CLEAR_GRID_VIEW:
      // Clear from localStorage
      try {
        localStorage.removeItem("isSmallGrid");
      } catch (e) {
        console.error("Failed to clear isSmallGrid from localStorage:", e);
      }
      return { ...INIT_STATE };

    default:
      return state;
  }
};
